import { useTranslation } from "react-i18next";
import { PointsLevelsInfoDialog } from "./PointsLevelsInfoDialog";
import { calculateLevelAndProgress } from "@/utils/calculateLevel";

export function CurrentLevelInfo({ score }: { score: number }) {
  const { t } = useTranslation();
  const { level, toNext } = calculateLevelAndProgress(score);
  const label = t(`community.userLevels.${level}`);

  return (
    <>
      <div className="text-sm text-blue-600 font-semibold">
        {t("community.levelInfo.levelAndLabel", { level, label })}
      </div>
      {toNext !== null && (
        <div className="text-xs text-gray-500 mt-1 flex items-center gap-2">
          {t("community.levelInfo.pointsToLevelUp", { count: toNext })}
          <PointsLevelsInfoDialog />
        </div>
      )}
    </>
  );
}
